import { AsyncPipe, CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, input } from '@angular/core';
import { Validators } from '@angular/forms';

import { of } from 'rxjs';

import { FormComponent } from '@camelot/form-basic';
import { RadioComponent } from '@camelot/form-input';
import { InputRadio } from '@camelot/form-model';
import { CamIconType } from '@camelot/icons';
import { TranslatePipe } from '@camelot/translation';
import { ButtonComponent, DepartmentProfessionsComponent, LoaderComponent } from '@camelot/ui';

import { CamTranslationCore } from '../../../../../translation.service';
import { BaseTemplateComponent } from '../base-template';

@Component({
  selector: 'cam-call-template',
  templateUrl: './call-template.component.html',
  styleUrls: ['./call-template.component.scss'],
  imports: [
    CommonModule,
    AsyncPipe,
    DepartmentProfessionsComponent,
    LoaderComponent,
    ButtonComponent,
    TranslatePipe,
    RadioComponent,
    FormComponent,
  ],
})
export class CallTemplateComponent extends BaseTemplateComponent {
  ctaService = input.required<{
    callBack: (id: number, request: { isSuccess: boolean }) => any;
  }>();

  formService = input.required<{
    getCallForm: () => any;
    formatCallResult: (data: any) => { isSuccess: boolean };
  }>();

  public reachInput: InputRadio<boolean> = new InputRadio<boolean>({
    key: 'reached',
    label: 'core.communication-handler.cta.call.reachclient.label',
    validators: [Validators.required],
    options: of([
      {
        id: true,
        name: 'core.radio.yes',
        icon: CamIconType.CheckLight,
      },
      {
        id: false,
        name: 'core.radio.no',
        icon: CamIconType.CancelLight,
      },
    ]),
    value: false,
  });

  constructor() {
    super();
    CamTranslationCore.getInstance();
    this.reachInput.createFormControl();

    this._registerSubscription(
      this.reachInput.changeValue$.subscribe(x => {
        if (!x) {
          this.form.set([]);
        } else {
          this.setForm();
        }
      })
    );
  }

  public setForm() {
    this.form.set(this.formService().getCallForm());
  }

  public override askValidation(): void {
    if (!this.reachInput.value) {
      this._sendAll();
      return;
    }
    super.askValidation();
  }

  public override send(data: any) {
    const request = this.reachInput.value
      ? this.formService().formatCallResult(data)
      : { isSuccess: this.reachInput.value };

    this.requestState.asked();
    this.ctaService()
      .callBack(this.currentItem.id, request)
      .subscribe({
        complete: () => {
          this.next();
          this.requestState.completed();
        },
        error: (error: HttpErrorResponse) => {
          this.requestState.onError(error.status, error.statusText);
        },
      });
  }

  private _sendAll() {
    for (let item of this.items()) {
      this.requestState.asked();
      this.ctaService()
        .callBack(item.id, { isSuccess: false })
        .subscribe({
          complete: () => {
            this.next();
          },
        });
    }
  }
}
